// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.AssertionRpcAuth
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr
import org.multipaz.cbor.toDataItemDateTimeString

fun AssertionRpcAuth.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "WtOZUpkF0aYQfUBBHJg6vGpSvpgZj-PzQGjB8lj5h4I")
val AssertionRpcAuth_cborSchemaId = ByteString(90, -45, -103, 82, -103, 5, -47, -90, 16, 125, 64, 65, 28, -104, 58, -68, 106, 82, -66, -104, 25, -113, -29, -13, 64, 104, -63, -14, 88, -7, -121, -126)

fun AssertionRpcAuth.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "RpcAuth")
    builder.put("target", Tstr(this.target))
    builder.put("method", Tstr(this.method))
    builder.put("nonce", Bstr(this.nonce.toByteArray()))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    builder.put("clientId", Tstr(this.clientId))
    builder.put("payloadHash", Bstr(this.payloadHash.toByteArray()))
    return builder.end().build()
}

fun AssertionRpcAuth_fromDataItem(dataItem: DataItem): AssertionRpcAuth {
    val target = dataItem["target"].asTstr
    val method = dataItem["method"].asTstr
    val nonce = ByteString(dataItem["nonce"].asBstr)
    val timestamp = dataItem["timestamp"].asDateTimeString
    val clientId = dataItem["clientId"].asTstr
    val payloadHash = ByteString(dataItem["payloadHash"].asBstr)
    return AssertionRpcAuth(
        target = target,
        method = method,
        nonce = nonce,
        timestamp = timestamp,
        clientId = clientId,
        payloadHash = payloadHash,
    )
}
